// Starting points guide capture without supplying facts on the user's behalf.
export const CAPTURE_PATHS = {
  idea: {
    title: 'Catch an idea',
    hint: 'What is the idea, and what would you like to try first?',
    audio: 'Talk it through before you lose the thread.',
    photo: 'Add a sketch, screenshot, or inspiration.',
    placeholder: 'A photo series of the same street in every season. Start with the old cinema…',
    question: 'What was that photo project I wanted to try?',
  },
  find: {
    title: 'Keep a great find',
    hint: 'What did you find, and what made you want to keep it?',
    audio: 'Say what it is and why it caught your eye.',
    photo: 'Keep the café, book, recipe, or little detail.',
    placeholder: 'This is the café with the lemon cake. Come back after the Saturday market…',
    question: 'Which café did I want to go back to?',
  },
  decision: {
    title: 'Remember why',
    hint: 'What did you decide, and what tipped the balance?',
    audio: 'Keep the reasoning while it’s still fresh.',
    photo: 'Add the whiteboard, plan, or notes behind it.',
    placeholder: 'Keep the first version small. People need to find their own notes before we add sharing…',
    question: 'Why did we leave sharing out of the first version?',
  },
};
